import React from "react";

/**
 * Section Header Component
 * 
 * @param {Object} props Component properties
 * @param {React.ReactNode} props.icon Icon component to display
 * @param {string} props.title Title text
 * @param {string} props.description Description text
 */
const SectionHeader = ({ icon, title, description }) => (
  <div className="flex items-center gap-4 mb-6">
    <div className="p-3 rounded-lg bg-primary/10">{icon}</div>
    <div>
      <h2 className="card-title text-lg font-semibold">{title}</h2>
      <p className="text-base-content/60 text-sm">{description}</p>
    </div>
  </div>
);

export default SectionHeader; 